import { FormProvider } from "react-hook-form";
import { DialogContent } from "@/view/components/ui/dialog";
import Steps from "./components/Steps";
import PersonalInfoForm from "./components/PersonalInfoForm";
import AddressForm from "./components/AddressForm";
import BankInfoForm from "./components/BankInfoForm";
import Header from "./components/Header";
import usePersonalInfoModal from "./usePersonalInfoModal";

interface PersonalInfoModalProps {
  onBack: () => void;
  onContinue: () => void;
}

export default function PersonalInfoModal({
  onBack,
  onContinue,
}: PersonalInfoModalProps) {
  const { steps, title, form, step, setStep } = usePersonalInfoModal();

  function handleBack() {
    if (step > 0) {
      setStep(step - 1);
    } else {
      onBack();
    }
  }

  return (
    <DialogContent className={"min-w-[760px]"} closeOnClickOutside={false}>
      <div>
        <Header title={title[step]} onBack={handleBack} />
        <Steps visible={step < 3} totalSteps={3} />
        <FormProvider {...form}>
          <PersonalInfoForm visible={steps.personalInfo} />
          <AddressForm visible={steps.address} />
          <BankInfoForm visible={steps.bankInfo} onContinue={onContinue} />
        </FormProvider>
      </div>
    </DialogContent>
  );
}
